import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectOrganization = createSelector(
  [(store: RootState) => store.organizationShow.organization],
  (data) => data
);
